/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/printer_medium'
export default icon
